"use client";
import React, { useState } from 'react';
import { LogOut } from 'lucide-react';
import LogoutModal from './LogoutModal';

const LogoutButton = ({ isCollapsed, iconOnly = false }) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // iconOnly: compact icon-only button for the footer profile strip
  if (iconOnly) {
    return (
      <>
        <button
          onClick={() => setShowLogoutModal(true)}
          title="Sign Out"
          className="flex-shrink-0 p-1.5 rounded-lg text-gray-400 hover:bg-red-100 hover:text-red-600 transition-colors"
        >
          <LogOut className="w-4 h-4" />
        </button>
        <LogoutModal isOpen={showLogoutModal} onClose={() => setShowLogoutModal(false)} />
      </>
    );
  }

  return (
    <>
      <button
        onClick={() => setShowLogoutModal(true)}
        className={`w-full flex items-center gap-3 px-3 py-2.5 text-gray-600 hover:bg-red-50 hover:text-red-600 rounded-xl transition-colors group relative ${
          isCollapsed ? 'justify-center' : ''
        }`}
        title="Sign Out"
      >
        <LogOut className="w-4 h-4 flex-shrink-0" />
        {!isCollapsed && <span className="font-medium text-sm">Sign Out</span>}
      </button>

      {/* Logout Modal */}
      <LogoutModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
      />
    </>
  );
};

export default LogoutButton;
